import {onFind,} from "@elements/init-modules-in-scope";
import * as formValidation from '@elements/form-validation';
import {translate} from '@elements/translations';

const selectors = {
    base: '.js-validate-zip-form',
    input: '.js-validate-zip-input',
};

const allowedZipCodes = [
    1659, 3703, 3704, 3711, 3713, 3714, 3715, 3716,
    3717, 3718, 3722, 3723, 3724, 3725, 3758, 3762,
    3763, 3764, 3765, 3766, 3770, 3771, 3772, 3773,
    3775, 3776, 3777, 3778, 3780, 3781, 3782, 3783,
    3784, 3785, 3792, 3048
];

export function init() {
    onFind(selectors.base, function (customValidatorForm) {
        let formInstance;
        formValidation.getApi(customValidatorForm).then((formApi) => {
            formInstance = formApi.getFormInstance();
           onFind(selectors.input, function (input) {
               if (!input) {
                   console.warn('No input found for zip validation');
                   return
               }
               let inputName = input.getAttribute('name');
                   formInstance.fields[inputName] = {
                       validators: {
                           callback: {
                               message:  translate('validation.zip-not-allowed'),
                               callback: function (input) {
                                   if (input.value === '') {
                                       return true;
                                   }
                                   const zip = parseInt(input.value, 10);
                                   return allowedZipCodes.includes(zip);
                               }
                           },
                           notEmpty: {
                               enable: true
                           },
                       }
                   }
           });
        });
    });
}